import type { MillisecondsDuration, } from "@bracket/types";
import { ACTIVE_THEME_NAME, DEFAULT_THEME_NAME, setTheme, } from "@bracket/ui/themes";
import type { ThemeName, } from "@bracket/ui/types";
import type { IBracketStore, } from "@store/types";
import { produce } from 'immer';
import type { StateCreator, } from "zustand";
import type { Store } from '../useStore';
import type { IUISlice, MenuState, } from "./types";



export const createUISlice: StateCreator<IBracketStore, [], [], IUISlice> = ( set, get, ) => {


	let _pollListener: NodeJS.Timeout | null = null;
	const _pollInterval: MillisecondsDuration = 5000;


	const fetch = async () => {

		set(produce<Store>(state => {
			state.ui.ready = false;
			state.ui.fetching = true;
		}));

		await _restore();

		set(produce<Store>(state => {
			state.ui.ready = true;
			state.ui.fetching = false;
		}));

	};


	const reset = () => {
		console.warn("store:ui::reset:: not implemented");
	};


	const resetAsync = async () => {
		console.warn("store:ui::resetAsync:: not implemented");
	};


	const setMenuState = ( next: MenuState, ) => {
		set(produce<Store>(state => {
			state.ui.menuState = next;
		}));
	};


	const setRevealed = ( next: boolean ) => {
		set(produce<Store>(state => {
			state.ui.revealed = next;
		}));
	};


	const setThemeMode = ( mode: ThemeName, ) => {
		set(produce<Store>(state => {
			state.ui.themeMode = mode;
			setTheme(mode);
		}));
	}

	const _restore = async () => {
		set(produce<Store>(state => {
			state.ui.menuState = "CLOSED";
			state.ui.themeMode = ACTIVE_THEME_NAME;
			setTheme(ACTIVE_THEME_NAME);
		}));
	};

	const _setDefaults = async () => {
		set(produce<Store>(state => {
			state.ui.menuState = "CLOSED";
			state.ui.themeMode = DEFAULT_THEME_NAME;
			setTheme(DEFAULT_THEME_NAME);
		}));
	};


	const _collectGarbage = () => {
		const lastReloadTime = globalThis.localStorage.getItem("last-reload-time");
		const minTimeBetweenReloads = globalThis.localStorage.getItem("min_time_between_reloads");
		if(lastReloadTime && minTimeBetweenReloads && Date.now() - Number(lastReloadTime) < Number(minTimeBetweenReloads) * 1000) {
			globalThis.localStorage.removeItem("last-reload-time");
		}
	};


	const _poll = () => {
		_collectGarbage();
	};


	const _stopPolling = () => {
		if(_pollListener) {
			clearInterval(_pollListener);
			_pollListener = null;
		}
	};


	const _startPolling = () => {
		_stopPolling();
		_pollListener = setInterval(_poll, _pollInterval);
	};



	// Use a small delay to ensure debugger is attached
	setTimeout(async () => {
		await fetch();
		_startPolling();
	}, 0);


	return {
		menuState: "CLOSED",
		themeMode: ACTIVE_THEME_NAME,
		ready: false,
		fetching: false,
		revealed: false,
		fetch,
		reset,
		resetAsync,
		setMenuState,
		setRevealed,
		setThemeMode,
	};

};
